import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const harness = defineConnector({
  identifier: "harness",
  name: "Harness",
  tagLine: "Modern software delivery platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://app\\.harness\\.io/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Harness API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Harness, go to **Account Settings → Access Control → API Keys** and create a new API key with a service account token.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Harness API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.harness.io/gateway/ng/api/user/currentUser",
  },
});
